import { IS_BROWSER, WINDOW } from "AtomicUtils/environment"

export const scrollToElementId = (id, options = {}, callBack = () => {}) => {
  const element = document.querySelector(`[data-id="${id}"]`)

  if (IS_BROWSER && id && element) {
    scrollToNode(element, { ...options }, callBack)
  }
}

export const scrollToNode = (
  target,
  { behavior = 'smooth', block = 'start' } = {},
  callback = () => {}
) => {
  if (IS_BROWSER && target) {
    target.scrollIntoView({
      behavior,
      block
    })
    setTimeout(callback,1000)
  }
}



// WEBPACK FOOTER //
// ./src/AtomicUtils/scroll.js